import { createApp } from "vue";
import App from "./App.vue";
import router, { initializeUserState } from "./router";
import pinia, { GAME_ID } from "./stores";
import i18n from "./i18n";
import { useLanguageStore } from "./stores/language";
import "./style.css";
const app = createApp(App);

app.use(router);
app.use(pinia);
app.use(i18n);

// 初始化语言和用户状态后再挂载应用
(async () => {
  try {
    // 1. 初始化语言设置（用 app 的 pinia 取 store，保证与路由守卫读到同一实例）
    const languageStore = useLanguageStore(pinia);
    await languageStore.initializeLanguage(GAME_ID);

    // 2. 初始化用户状态
    await initializeUserState();

    // 3. 无游戏配置则先切到维护页
    if (!languageStore.hasGameConfig) {
      router.replace({ name: "maintenance" });
    }

    // 4. 挂载应用
    app.mount("#app");
  } catch (error) {
    console.error("Failed to initialize app:", error);
    // 即使出错也挂载应用，使用默认语言
    app.mount("#app");
  }
})();
